import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const SuccessMark = ({
  className
}) => /*#__PURE__*/React.createElement(FontAwesomeIcon, {
  className: className,
  icon: faCheckCircle
});

SuccessMark.propTypes = {
  className: PropTypes.string
};
export default styled(SuccessMark)`
  font-size: 19px;
  color: #658d30;
  margin-right: 10px;
`;